import React from 'react';
import cn from 'classnames';
import Carousel, {
	ICarouselProps,
	CarouselItem,
} from 'tbk-components/src/components/Carousel';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ILargeGalleryProps extends ICarouselProps {
	/**
	 * Large Gallery Images - Images should be 1440px X 800px
	 */
	images?: IImage[];
}

/**
 * Simple Gallery
 * @block
 * @requiresHooks
 */
const LargeGallery: React.FC<ILargeGalleryProps> = ({
	className,
	images = [],
}) => (
	<Carousel id="large-gallery-carousel" className={className || cn('simple-gallery')}>
		{images.map((image, i) => (
			<CarouselItem key={i}>
				<Image {...image} />
			</CarouselItem>
		))}
	</Carousel>
);

export default LargeGallery;
